module.exports = __webpack_public_path__ + "img/partner_01.268a481f.png";